import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'action-feedback',
  template: require('./action-feedback.component.html'),
  styles: [require('./action-feedback.component.scss')]
})
export class ActionFeedbackComponent implements OnInit {
  public title: string;
  public subtitle: string;

  constructor(
    @Inject('LanguageService') public LanguageService,
    @Inject('$state') public $state,
    @Inject('$translate') public $translate,
  ){}

  ngOnInit() {
    this.title = this.$translate.instant(`hospital_booking.action_feedback.${this.$state.params.action}`);
    this.subtitle = this.$translate.instant(`hospital_booking.action_feedback.${this.$state.params.action}_subtitle`)
  }

  isSuccessful() {
    return this.$state.params.action !== 'unavailable';
  }
}


// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/hospital-booking/action-feedback/action-feedback.component.ts